import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { BANK_NOC_OPTIONS } from "../post-inspection-diy-loan-details/constant";

const PostInspectionDiyLoanBankNoc = ({
    selectedNoc,
    handleSelection,
    updateAllowed
}) => {
    return (
        <div styleName={"styles.bankNoc"}>
            <h2>Do you have Valid Bank NOC?</h2>
            {BANK_NOC_OPTIONS.map(({type, label}) => (
                <div key={`valid-noc-${type}`} styleName={"styles.validNoc"}>
                    <label>
                        <input
                            type="radio"
                            value={type}
                            checked={selectedNoc === type}
                            onChange={(e) => handleSelection(e, "NOC")}
                            disabled={!updateAllowed}
                        />
                        {label}
                    </label>
                </div>
            ))}
        </div>
    );
};

PostInspectionDiyLoanBankNoc.propTypes = {
    handleSelection: PropTypes.func,
    selectedNoc: PropTypes.string,
    updateAllowed: PropTypes.bool
};
export default PostInspectionDiyLoanBankNoc;
